import {
  useAllZoomAccountsQuery,
  ZoomAccountFieldsFragment,
} from 'core/graphql';

interface IZoomAccountsHook {
  data: ZoomAccountFieldsFragment[];
  loading: boolean;
  error?: string;
  refetch: () => void;
}

/** All Zoom sub-accounts (no relay pagination needed — small fixed set). */
export const useZoomAccounts = (isActive?: boolean): IZoomAccountsHook => {
  const { data, loading, error, refetch } = useAllZoomAccountsQuery({
    variables: { isActive, first: 100 },
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  return {
    data: (data?.allZoomAccounts?.edges ?? [])
      .map((edge) => edge?.node)
      .filter((node): node is ZoomAccountFieldsFragment => Boolean(node)),
    loading,
    error: error?.message,
    refetch: () => {
      refetch();
    },
  };
};
